var exports = {
  "D": "x234b8571--44a301--carousel",
};

module.exports = exports;
